import React from 'react'
import {Grid, Paper, TextField, Button,  Snackbar} from '@mui/material'

import ListItemText from "@mui/material/ListItemText";
import makeStyles from '@mui/styles/makeStyles';
import MuiAlert from "@mui/material/Alert";
import {BASE_URL_MESSENGER_API} from "../../Const";
import MessengerIcon from "../../assets/icons/ic_messenger.svg";

const Alert = React.forwardRef(function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

const useStyles = makeStyles(theme => ({
    labelRoot: {
        right: 0
    },
    shrink: {
        transformOrigin: "top right"
    }
}));


export class LoginMessengerComponent extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            code: "",
            openSnackbar: false,
            message: ""
        }
    }


    FormPropsTextFields = () => {

        const handleOnchange = (e) => {
            this.setState({code: e.target.value})
        }


        const classes = useStyles();


        return (
            <div>
                <TextField
                    fullWidth
                    required
                    onChange={handleOnchange}
                    style={{direction: "rtl", marginTop: 48}}
                    id="standard-required"
                    label="کد اعتبارسنجی"
                    placeholder="******"
                    InputLabelProps={{
                        classes: {root: classes.labelRoot, shrink: classes.shrink}
                    }}
                />
            </div>
        );
    }

    onSubmit = (e) => {
        fetch(BASE_URL_MESSENGER_API+ 'login', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin': '*'
            },
            body: JSON.stringify({
                code: this.state.code,
                temp_user_token: localStorage.getItem("pwa_temp_user_messenger_token"),
            })
        })
            .then(response => response.json())
            .then(result => {
                if (result.code === "200") {
                    localStorage.removeItem("pwa_temp_user_messenger_token")
                    localStorage.setItem("pwa_messenger_token", result.data.token)

                    window.location.assign('messenger/dialogs')
                } else {
                    this.setState({openSnackbar: true, message: result.message})
                }


            })
    }


    render() {
        const handleCloseSnackbar = (e) => {
            this.setState({openSnackbar: false})
        }

        const paperStyle = {padding: 20, height: '70vh', width: 280, margin: "20px auto"}
        const btnStyle = {marginTop: 24, backgroundColor: '#FF1744', color: 'white'}

        return (
            <Grid>
                <Paper elevation={10} style={paperStyle}>
                    <Grid align='center'>
                        <img  alt={""} width={96} height={96} src={MessengerIcon}/>
                        <ListItemText>ورود به همه کارا</ListItemText>
                    </Grid>
                    <this.FormPropsTextFields/>

                    <Button onClick={this.onSubmit} type='submit' variant="contained" style={btnStyle} fullWidth>ارسال
                        کد</Button>
                </Paper>

                <Snackbar open={this.state.openSnackbar} autoHideDuration={6000} onClose={handleCloseSnackbar}>
                    <Alert onClose={handleCloseSnackbar} severity="error" sx={{width: '100%'}}>
                        {this.state.message}
                    </Alert>
                </Snackbar>
            </Grid>
        );
    }


}
